import script from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBreakdownView.vue?vue&type=script&setup=true&lang=js"

import "./CostBreakdownView.vue?vue&type=style&index=0&id=eb717272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb717272"]])

export default __exports__